import type { ChapterDef, SceneDef } from '@plotjack/core';
import { BOOK1_STORY } from '../data/story';
import { fillVars } from '@plotjack/core';
import { useEffect } from 'react';
import { audio } from '../audio/engine';

interface Props {
  chapter: ChapterDef;
  quest?: string;
  firstScene?: SceneDef;
  onContinue: () => void;
}

export function ChapterIntro({ chapter, quest, firstScene, onContinue }: Props) {
  const vars = BOOK1_STORY.variables ?? {};
  useEffect(() => {
    audio.playSfx('page_turn');
    void audio.playLine(chapter.titleCardText);
  }, [chapter.titleCardText]);
  return (
    <section className="screen chapter-intro" aria-labelledby="chapter-title">
      <div className="chapter-card panel">
        <p className="eyebrow">Chapter {chapter.number}</p>
        <h1 id="chapter-title">{chapter.title}</h1>
        <p className="chapter-subtitle">{chapter.subtitle}</p>
        <p className="chapter-gag">{chapter.titleCardText}</p>
        {quest && (
          <p className="chapter-quest">
            <span className="quest-label">Quest</span> {quest}
          </p>
        )}
        {firstScene?.previously && (
          <p className="chapter-where">
            <span className="quest-label">Where we are</span> {fillVars(firstScene.previously, vars)}
          </p>
        )}
        <button type="button" className="btn btn-primary" onClick={onContinue} autoFocus>
          Start chapter {chapter.number}
        </button>
      </div>
    </section>
  );
}
